<div class="auth" style="background-color: whitesmoke">
  <!-- <app-header></app-header> -->

  <!-- <div class="logo-src"></div> -->
  <div class="row d-flex justify-content-center g-0">
    <div class="slider-light">
      <div
        class="position-relative h-100 d-flex justify-content-center align-items-center"
      >
        <div class="slide-img-bg"></div>
        <div class="slider-content" style="color: black">
          <h3 style="text-align: center">
            <!-- <h4 class="mb-0 text-center"> -->
            <img src="../../../assets/images/logo-blue.png" width="200" />
            <div>&nbsp;</div>
            <!-- </h4> -->
          </h3>
          <div>&nbsp;</div>

          <h3
            class="me-3 pe-3 ms-3 ps-3"
            style="text-align: center"
            [innerHTML]="displayMessage"
          ></h3>
        </div>
      </div>
    </div>
  </div>
</div>
